<template>
  <div class="container">
    <mad-form @submit.prevent="submit">
      <mad-form-item label="Email">
        <mad-input v-model="form.email" />
      </mad-form-item>
      <mad-form-item label="Password">
        <mad-input v-model="form.password" />
      </mad-form-item>
      <mad-form-item label="First name">
        <mad-input v-model="form.first_name" />
      </mad-form-item>
      <mad-form-item label="Last name">
        <mad-input v-model="form.last_name" />
      </mad-form-item>
      <mad-form-item label="Last name">
        <mad-select
          v-model="form.admin"
          :options="[{value: true, label: 'Admin user'}, {value: false, label: 'Normal user'}]"
        />
      </mad-form-item>

      <div class="spaced-row">
        <mad-button @click="clickCancel">
          <mad-icon mdi="arrow-left" />
        </mad-button>
        <div class="grow"></div>
        <mad-button color="brown" type="submit">
          <mad-icon mdi="check" />
          Create user
        </mad-button>
      </div>
    </mad-form>
  </div>
</template>

<script>
export default {
  data: () => ({
    form: {
      email: '',
      password: '',
      first_name: '',
      last_name: '',
      user_image: '',
      admin: false,
    },
  }),

  methods: {
    async submit() {
      await this.$store.dispatch('createUser', this.form,
      )
      this.$router.push(`/users`)
    },
    clickCancel() {
      this.$router.push(`/users`)
    },
  },
}
</script>

<style>
</style>
